export const environment = {
  appName: 'SITT-Partnerportal',
  production: false,
  api: 'http://localhost:3100',
  sentry: {
    dsn: '',
  },
};
